import { render, staticRenderFns } from "./EditSponsorDetails.vue?vue&type=template&id=be73b858"
import script from "./EditSponsorDetails.vue?vue&type=script&lang=js"
export * from "./EditSponsorDetails.vue?vue&type=script&lang=js"
import style0 from "./EditSponsorDetails.vue?vue&type=style&index=0&id=be73b858&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports